(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('ListRepository', [
        '$q',
        'AprimaRestangular',
        'MessageTypes',
        ListRepository
    ]);

    function ListRepository(
        $q,
        AprimaRestangular,
        MessageTypes
    ) {

        var service = {
            getList: getList
        };

        return service;

        function getList(listName, params, cache) {
            if (listName === 'appointmentduration') {
                //these are not defined in the database
                var durations = getAppointmentDurations();
                return $q.when(durations);
            }
            else if(listName === 'messagetypessupportedforcreate') {
                return getMessageTypesSupportedForCreate(cache);
            }

            var listPromise = AprimaRestangular.get()
                .all('lists/' + listName)
                .withHttpConfig({
                    cache: cache,
                })
                .getList(params);

            return listPromise;
        }

        function getAppointmentDurations() {
            var defaultDurationList = [
                getMinutesDurationObject(10),
                getMinutesDurationObject(15),
                getMinutesDurationObject(20),
                getMinutesDurationObject(30),
                getMinutesDurationObject(45),
                getMinutesDurationObject(60),

                getHoursDurationObject(2),
                getHoursDurationObject(3),
                getHoursDurationObject(4),
                getHoursDurationObject(8)
            ];

            return defaultDurationList;
        }

        function getMinutesDurationObject(minutes, prefix, suffix) {
            var opts = _.defaults({
                minutes: minutes,
                prefix: prefix,
                suffix: suffix
            }, {
                prefix: minutes,
                suffix: 'minutes'
            });


            return {
                Id: minutes,
                Description: opts.prefix + ' ' + opts.suffix
            };
        }

        function getHoursDurationObject(hours) {
            return getMinutesDurationObject(hours * 60, hours, 'hours');
        }

        function getMessageTypesSupportedForCreate(cache) {
            return $q.all([getList('messagetypes', null, cache), getList('messagesubtypes', null, cache)])
                .then(function(lists){
                    var types,subTypes, allTypes;

                    var supportedTypes = MessageTypes.SupportedMessageTypesForCreate.Types,
                        supportedSubTypes = MessageTypes.SupportedMessageTypesForCreate.SubTypes;

                    types = _(lists[0]).filter(function (t) {
                        return (_.findIndex(supportedTypes, {id: t.Id}) >= 0);
                    }).map(function(t) {
                        return {
                            messageTypeId: t.Id,
                            messageSubTypeId: null,
                            name: t.Name,
                            requiredFeature: _.find(supportedTypes, {id: t.Id}).requiredFeature
                        };
                    }).value();

                    subTypes = _(lists[1]).filter(function (t) {
                        return (_.findIndex(supportedSubTypes, {id: t.Id}) >= 0);
                    }).map(function(t) {
                        return {
                            messageTypeId: t.MessageTypeId,
                            messageSubTypeId: t.Id,
                            name: t.Name,
                            requiredFeature: _.find(supportedSubTypes, {id: t.Id}).requiredFeature
                        };
                    }).value();

                    allTypes = _(_.union(types, subTypes)).sortBy('name').value();

                    return allTypes;
                });
        }
    }

})(window.angular);
